import React, { useState } from 'react';
import RewyLayout from '../../layouts/rewy/index'
import StarIcon from '../../../content/assets/images/star-icon.png';
import HowItsWork from '../../../content/assets/images/howitworks.png';
import {Link} from 'gatsby';
import { Flex, Box, Button, Heading, Input } from 'theme-ui';

const HowItWork = () => {

  const [zipValue, setZipValue] = useState('');

  const zipChange = (event) => {
    setZipValue(event.target.value)
  };

  const zipHandler = () => {
    if (!zipValue.length) {
      localStorage.removeItem('zip');
    }

    if (zipValue.length >= 3 && zipValue.length <= 5) {
      localStorage.setItem('zip', zipValue);
    }
  }

  return (
    <RewyLayout>
      <section className="how-its-work-area pt-70">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="how-its-work-content">
                            <span className="sub-title">
                                {/* <img src={StarIcon} alt="image"/> */}
                                გსურს დისტანციურად დასაქმება?
                            </span>
                <h5>ისწავლე ინგლისური ონლაინ</h5>
                {/* <p>მხოლოდ თვეში 50 ლარად</p> */}
                <div className="inner-box">
                  <div className="single-item">
                    <div className="count-box">
                      1
                    </div>
                    <h3>მასწავლებელთან ერთად</h3>
                    <p>დისტანციურად </p>
                  </div>
                  <div className="single-item">
                    <div className="count-box">
                      2
                    </div>
                    <h3>უფასო ინგლისური გაკვეთილები</h3>
                    <p>სიტყვები, გრამატიკა, დიალოგები, ტესტები</p>
                  </div>
                  <div className="single-item">
                    <div className="count-box">
                      3
                    </div>
                    <h3>დასაქმება სწავლის შემდეგ</h3>
                    <p>წარმატებული სტუდენტები დასაქმდებიან</p>
                  </div>
                  <div className="row">
                  <div className="col-lg-6 col-md-6">

                    <Link to="https://inglisuri.dabudu.com/stsavlis-pirobebi" className="default-btn">
                                    <i className="flaticon-right"></i> 
                                    სწავლის პირობები<p></p>
                    </Link>

                    </div>

                    <div className="col-lg-5 col-md-6">

                    <Link to="/registracia" className="default-btn">
                    <i className="flaticon-right"></i> 
                      რეგისტრაცია <p></p>
                      </Link>

                    </div>
                    </div>
                    

                  {/* <div className="subscribe-content">
                                   <form className="newsletter-form">
                                    <input type="text" className="input-newsletter" name="zip" label="Zip" onChange={zipChange} placeholder="ZipCode" required />
                                    <Link as={Link} to="/compliance" variant="primary" aria-label="Download Report" onClick={zipHandler} className="default-btn">
                                     <i className="flaticon-tick"></i> 
                                      Get Started <span></span>
                                    </Link>
                                   </form>
                                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="how-its-work-image">
                <img src={HowItsWork} alt="image"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </RewyLayout>
  );
};

export default HowItWork;